<script setup>
import { ref } from "vue";

import Grid from "../components/Grid.vue";

import { updateTevalis } from "../functions/Tevalis";

import { createMenu as _createMenu, menus, getMenus } from '../functions/Menus';

import http from "@/axios-config";

import Button from "../components/Button";

import { useMenuInfoStore } from "@/stores/menu-info";

import { useAppState } from "@/stores/app-state";
import ConfirmModalVue from "../components/modals/ConfirmModal.vue";

const appState = useAppState();
const menuStore = useMenuInfoStore();

const newSite = ref({});

await getMenus();

async function saveSites() {
    const response = await http.post("/api/sites/update", { sites: menuStore.sites });
}

async function syncMenu(site) {
    const response = await http.post(`/api/sites/${site.id}/sync`);
}

const addSiteResponse = ref({});

async function addSite(site) {
    addSiteResponse.value = await http.post(`/api/sites/create`, { ...site });

    newSite.value = {};

    menuStore.getMenuInfo()
}

async function toggleTevalis() {
    const response = await http.get("/api/tevalis/toggle");

    menuStore.using_tevalis = !menuStore.using_tevalis;
}

await menuStore.getMenuInfo();

async function deleteMenu(menu_slug) {
    const response = await http.delete(`/api/menu/${menu_slug}`)
        .then(function (response) {
            if (response.data.deleted == true) {
                getMenus();
                return response;
            } else {
                return response;
            }
        }).catch(error => error);
    return response;
}

async function deleteVenue(id) {
    let can_delete = true;
    let assigned_menu = '';
    //check if site has menu slug
    const new_venues = menuStore.sites.filter(function (site) {
        if (site.id != id) {
            return true;
        } else if (site.menu_slug == null) {
            can_delete = true;
            return false;
        } else {
            assigned_menu = site.menu_slug;
            can_delete = false;
            return true;
        }
    });

    if (can_delete) {
        menuStore.sites = new_venues;
        const response = await http.delete(`/api/sites/${id}`)
            .then(function (response) {
                if (response.data.deleted == true) {
                    getMenus();
                    return response;
                } else {
                    return response;
                }
            }).catch(error => error);
        return false;
    } else {
        const response = {
            data: {
                deleted: false,
                message: `Unable to delete as this Venue has the ${assigned_menu} menu assigned.`
            }
        };
        return response;
    }
}

appState.tevalisUpdating = false;

</script>

<template>
    <div class="content__inside--small">
        <div class="content__header">
            <div>
                <h1>System Settings</h1>
                <p>Update menu and venue information from Tevalis</p>
            </div>
        </div>
        <Grid :columns="'repeat(1, 1fr)'">
            <Grid :columns="'repeat(2, 1fr)'">
                <div class="grid-item">
                    <h2>Update Tevalis nightly?</h2>
                    <div class="tevalis-yes" v-if="menuStore.using_tevalis">Enabled</div>
                    <div class="tevalis-no" v-else>Disabled</div>
                    <Button :method="toggleTevalis">Toggle Tevalis nightly updates</Button>
                </div>
                <div class="grid-item">
                    <h2>Get the latest menu information from Tevalis</h2>
                    <Button :method="updateTevalis" v-if="!appState.tevalisUpdating">Update Tevalis</Button>
                    <Transition mode="out-in" :name="'fade'">
                        <div class="updating" v-if="appState.tevalisUpdating">
                            A Tevalis update has been scheduled and is running in the background.
                        </div>
                    </Transition>
                </div>
            </Grid>
            <Grid columns="repeat(2, 1fr)">
                <div class="grid-item sites-list">
                    <h2>Venue settings</h2>
                    <ul>
                        <li v-for="site in menuStore.sites">
                            <span>{{ site.name }}</span>
                            <div class="input-holder">
                                <input type="text" v-model="site.url" />
                                <div class="buttons">
                                    <Button :method="syncMenu" :args="site">Sync menu</Button>
                                    <ConfirmModalVue :args="site.id" :method="deleteVenue">
                                        <template v-slot:btn-content>
                                            <svg-vue icon="bin-outline"></svg-vue>
                                        </template>
                                        <template v-slot:modal-text>
                                            Delete <span class="italic">{{ site.name }}</span>?
                                        </template>
                                    </ConfirmModalVue>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <Button :method="saveSites">Save</Button>
                </div>
                <Grid>
                    <div class="grid-item">
                        <h2>Add venue</h2>
                        <div class="input-holder">
                            <input type="text" v-model="newSite.name" placeholder="Venue name" />
                            <input type="text" v-model="newSite.url" placeholder="Venue URL" />
                            <input type="text" v-model="newSite.tevalis_id" placeholder="Tevalis site ID" />
                            <small>The Tevalis site ID must match exactly to the site ID within Tevalis</small>
                            <br />
                            <p style="margin-top: 5px; padding: 10px; background: var(--grey-light)">Adding a new venue
                                will trigger Tevalis to pull the latest menu information</p>
                            <Button :args="newSite" :method="addSite">Add Venue & Update Tevalis</Button>
                        </div>
                        {{ addSiteResponse.message }}
                    </div>
                    <div class="grid-item menus-list">
                        <h2>Menu settings</h2>
                        <ul>
                            <li v-for="menu in menus">
                                <p class="menu-name">{{ menu.name }}</p>
                                <div class="input-holder">
                                    <div class="grid-dummy"></div>
                                    <ConfirmModalVue :args="menu.slug" :method="deleteMenu" :btn-content="'Delete'">
                                    </ConfirmModalVue>
                                </div>
                            </li>
                        </ul>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    </div>
</template>

<style scoped lang="scss">
@import '../../scss/partials/variables';

.updating {
    margin: 0 auto;
}

.tevalis-yes,
.tevalis-no {
    font-weight: bold;
    color: var(--green);
    background: var(--grey-light);
    padding: 10px;
    display: block;
    text-align: center;
    letter-spacing: 2px;
    font-size: 13px;
    text-transform: uppercase;
    margin-bottom: 10px;
}

.tevalis-no {
    color: var(--orange);
}

.sites-list {
    li {
        list-style: none;
        margin-bottom: 30px;

        .input-holder {
            display: flex;
            gap: 2px;

            input {
                margin: 0;
            }

            .button {
                white-space: nowrap;
            }

            .buttons {
                display: flex;
                gap: 2px;
            }
        }
    }
}

.menus-list {
    li {
        list-style: none;
        margin-bottom: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .menu-name {
            text-transform: uppercase;
        }

        .input-holder {
            width: 50%;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;
        }
    }
}

.button--danger {
    svg {
        min-width: 20px;
        min-height: 20px;
    }
}

.italic {
    font-style: italic;
}

@media screen and (max-width: $breakpoint-md) {
    .grid {
        display: block;
    }
}

@media screen and (max-width: $breakpoint-sm) {
    .input-holder {
        display: block;
    }

    .sites-list li .input-holder {
        display: block;

        .buttons {
            display: grid;
            grid-template-columns: 1fr 44px;
            margin-top: 2px;
        }
    }
}

.btn-edit {
    margin: 0;
    width: 100%;
}
</style>